Object.defineProperty(exports, '__esModule', { value: true });

var components_addon_component = require('./component-e150c9ed.js');



exports.PureCell = components_addon_component.PureCell;
